import { TacModel } from "../../state/tac/tacTypes";

// Should be an enum, but cannot use it due to the ancient, pre-historic version of Typescript.
export type AmeliorationOutcomeType = string;
export const AmeliorationOutcome  = {
  Success: 'success',
  Failure: 'failure',
  Declined: 'declined',
  Busy: 'busy',
};

export type AmeliorationDialogCallbacks = {
  onAcceptClicked?: () => void,
  onDeclineClicked?: () => void,
};

export type AmeliorationDialogContent = {
  headerText: string,
  bodyText: string,
  acceptText: string,
  declineText: string,
};

export type TransformationResult = {
  success: boolean,
  tacOut?: TacModel,
  successMessage?: string,
};

export type AmeliorationResult = {
  outcome: AmeliorationOutcomeType,
  tacOut?: TacModel,
  successMessage?: string,
};

export type AmeliorationArgs = {
  transform: (tacIn: TacModel) => TransformationResult,
  fastCheck?: (tacIn: TacModel) => boolean,
  dialogContent: AmeliorationDialogContent,
};

export type Amelioration = {
  start: (tacIn: TacModel) => Promise<AmeliorationResult>,
  checkWhetherCanAmeliorate: (tacIn: TacModel) => boolean | null,
};

export type AmeliorationCache = {
  tacIn: TacModel | null;
  canAmeliorate: boolean | null;
  tacOut?: TacModel | null;
  successMessage?: string | null,
};